<template>
  <b-card no-header border-variant="primary" v-if="status.orgEnabled">
    <template slot="header">
      <b-row>
        <b-col sm="6">
          Streak CRM
        </b-col>
        <b-col sm="6" class="text-right">
          <b-badge variant="success" v-if="status.linked && !status.lastError">Synced</b-badge>
          <b-badge variant="danger" v-else-if="status.lastError">Sync Error</b-badge>
          <b-badge variant="warning" v-else-if="status.syncEnabled">Pending</b-badge>
          <b-badge variant="secondary" v-else>Not Synced</b-badge>
        </b-col>
      </b-row>
    </template>

    <b-row v-if="!status.linked">
      <b-col sm="7">
        <span class="info"><strong>Status:</strong> Not synced to Streak</span>
        <span class="info text-muted" v-if="status.expectedBoxName"><strong>Box Name:</strong> {{ status.expectedBoxName }}</span>
      </b-col>
      <b-col sm="5" class="text-right">
        <b-button size="sm" variant="outline-secondary" :disabled="syncing" @click="preview">Preview</b-button>
        <b-button size="sm" variant="success" class="ml-2" :disabled="syncing" @click="sync">
          <i class="fa fa-refresh" :class="{ 'fa-spin': syncing }"></i> Enable &amp; Sync
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="status.linked">
      <b-col sm="7">
        <span class="info"><strong>Box:</strong> {{ status.boxName || status.expectedBoxName }}</span>
        <span class="info" v-if="status.lastSyncedAt"><strong>Last Synced:</strong> <date :value="status.lastSyncedAt" format="MM/DD/YYYY hh:mm a"></date></span>
        <span class="info" v-if="!status.syncEnabled"><b-badge variant="warning">Automatic sync disabled for this client</b-badge></span>
      </b-col>
      <b-col sm="5" class="text-right">
        <b-button size="sm" variant="outline-secondary" :disabled="syncing" @click="preview">Preview</b-button>
        <b-button size="sm" variant="primary" class="ml-2" :disabled="syncing" @click="sync">
          <i class="fa fa-refresh" :class="{ 'fa-spin': syncing }"></i> Sync Now
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="status.lastError" class="mt-2">
      <b-col sm="12">
        <b-alert show variant="danger" class="mb-0 py-1 px-2 small">
          <strong>Last sync failed<span v-if="status.lastErrorAt"> (<date :value="status.lastErrorAt" format="MM/DD/YYYY hh:mm a"></date>)</span>:</strong>
          {{ status.lastError }}
        </b-alert>
      </b-col>
    </b-row>

    <b-row v-if="previewResult" class="mt-2">
      <b-col sm="12">
        <b-alert show variant="info" dismissible class="mb-0 py-1 px-2 small" @dismissed="previewResult = null">
          <strong>Preview (no changes written):</strong>
          <ul class="mb-0 pl-3">
            <li v-for="(action, index) in previewResult.actions" :key="index">{{ describe(action) }}</li>
          </ul>
        </b-alert>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { mapGetters } from 'vuex'
import Date from '@/components/text/Date'

export default {
  name: 'StreakStatus',
  components: { Date },
  props: [ 'clientId' ],
  data () {
    return {
      previewResult: null
    }
  },
  computed: {
    ...mapGetters({
      status: 'streak/status',
      syncing: 'streak/syncing'
    })
  },
  methods: {
    refresh () {
      this.previewResult = null
      this.$store.dispatch('streak/fetchStatus', this.clientId)
    },
    sync () {
      this.previewResult = null
      this.$store.dispatch('streak/syncClient', { clientId: this.clientId })
        .then((result) => {
          if (result && result.status === 'unchanged') {
            this.$snotify.info('Already up to date in Streak')
          } else {
            this.$snotify.success('Synced to Streak')
          }
        })
        .catch((err) => {
          const message = (err.response && err.response.data && err.response.data.message) || err.message
          this.$snotify.error(message || 'Streak sync failed')
        })
    },
    preview () {
      this.$store.dispatch('streak/syncClient', { clientId: this.clientId, dryRun: true })
        .then((result) => {
          this.previewResult = result
        })
        .catch((err) => {
          const message = (err.response && err.response.data && err.response.data.message) || err.message
          this.$snotify.error(message || 'Streak preview failed')
        })
    },
    describe (action) {
      const labels = {
        'box.match': `Use existing box "${action.name}" (matched via ${action.via})`,
        'box.create': `Create box "${action.name}"`,
        'box.update': `Update box name/contacts (${action.contactCount} contacts)`,
        'box.field': `Set box field ${action.field}`,
        'contact.update': `Update contact ${action.name} (matched via ${action.via})`,
        'contact.create': `Create contact ${action.name}`,
        'contact.field': `Set ${action.field} on contact`,
        'skip': `Skipped: ${action.reason}`
      }
      return labels[action.type] || action.type
    }
  },
  watch: {
    clientId: {
      immediate: true,
      handler (id) {
        if (id) {
          this.refresh()
        } else {
          this.$store.dispatch('streak/clear')
        }
      }
    }
  }
}
</script>
